import { Plus } from 'lucide-react';
import Button from 'components/crm/ui/Button';
import Tag from 'components/crm/ui/Tag';
import DrawnGlyph from 'components/crm/ui/emptyState/DrawnGlyph';
import EmptyState from 'components/crm/ui/emptyState/EmptyState';
import useText from 'hooks/useText';
import { endSummary } from 'pages/prospection/callListItems';

/**
 * The call list with nothing left to call: `empty` (nothing made either) or
 * `finished` (with its reached and callbacks counts). Both lead to the global
 * list and to a new prospect.
 */
const CallListStates = ({ state, made, onOpenGlobal, onAddProspect }) => {
  const { text, plural } = useText('prospection');
  const finished = state === 'finished';
  const summary = finished ? endSummary(made) : null;

  return (
    <EmptyState
      compact
      glyph={<DrawnGlyph name={finished ? 'badgeCheck' : 'inbox'} />}
      title={text(finished ? 'finished.title' : 'empty.title')}
      description={text(finished ? 'finished.text' : 'empty.text')}
      action={
        <div className="flex flex-col items-center gap-3">
          {summary && (
            <div className="flex flex-wrap justify-center gap-2">
              <Tag>{plural('finished.reached', summary.reached)}</Tag>
              <Tag>{plural('finished.callbacks', summary.callbacks)}</Tag>
            </div>
          )}
          <div className="flex gap-2">
            <Button variant="secondary" onClick={onOpenGlobal}>
              {text('states.globalList')}
            </Button>
            <Button icon={Plus} onClick={onAddProspect}>
              {text('states.addProspect')}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default CallListStates;
